module.exports = __webpack_public_path__ + "static/img/02029D_3_R_20200331_fit.693f52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02029D_3_R_20200331_fit.png
// module id = T5RZ
// module chunks = 0